export default "__VITE_ASSET__DvwNCU8u__"